import { configureStore } from '@reduxjs/toolkit';
import landingPageReducer from './landingPageSlice';

import languageReducer from './languageSlice';
import messageReducer from './MessageSlice';

const store = configureStore({
  reducer: {
    landingPage: landingPageReducer,
    language: languageReducer,
    message: messageReducer,
  },
});

export default store;
